import React from "react";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import LowPriorityOutlinedIcon from "@mui/icons-material/LowPriorityOutlined";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import NotificationsPausedOutlinedIcon from "@mui/icons-material/NotificationsPausedOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";

const TABS = [
  { key: "reports", label: "Reports", translationKey: "reports", icon: AssessmentOutlinedIcon },
  { key: "assetCards", label: "Asset Cards", translationKey: "assetCards", icon: CreditCardOutlinedIcon },
  { key: "datastreamPriorities", label: "Datastream Priorities", translationKey: "datastreamPriorities", icon: LowPriorityOutlinedIcon },
  { key: "dashboardWidgets", label: "Dashboard Widgets", translationKey: "dashboardWidgets", icon: WidgetsOutlinedIcon },
  { key: "chartSampling", label: "Chart Sampling", translationKey: "chartSampling", icon: QueryStatsOutlinedIcon },
  { key: "voiceCommands", label: "Voice Commands", translationKey: "voiceCommands", icon: RecordVoiceOverOutlinedIcon },
  { key: "aiChatVoice", label: "AI Chat Voice", translationKey: "aiChatVoice", icon: RecordVoiceOverOutlinedIcon },
  { key: "weatherCron", label: "Weather Cron", translationKey: "weatherCron", icon: WbSunnyOutlinedIcon },
  { key: "fcmTokenCleanup", label: "FCM Cleanup", translationKey: "fcmTokenCleanup", icon: NotificationsPausedOutlinedIcon },
  { key: "googleSheets", label: "Google Sheets", translationKey: "googleSheets", icon: TableChartOutlinedIcon },
  { key: "auditLogs", label: "Audit Logs", translationKey: "auditLogs", icon: HistoryOutlinedIcon },
  { key: "subscriberPermissions", label: "Subscriber Permissions", translationKey: "subscriberPermissions", icon: AdminPanelSettingsOutlinedIcon },
];

const SystemConfigTabs = ({ activeTab, onChange, t }) => (
  <div className="system-config-tabs" role="tablist" aria-label={t.title}>
    {TABS.map((tab) => {
      const Icon = tab.icon;
      const isActive = activeTab === tab.key;
      return (
        <button
          type="button"
          key={tab.key}
          className={isActive ? "active" : ""}
          role="tab"
          aria-selected={isActive}
          onClick={() => onChange(tab.key)}
        >
          <Icon aria-hidden="true" />
          <span>{t.tabs?.[tab.translationKey] || tab.label}</span>
        </button>
      );
    })}
  </div>
);

export default SystemConfigTabs;
